import { render, staticRenderFns } from "./TaskFillTheBlankCard.vue?vue&type=template&id=3d835984&scoped=true&"
import script from "./TaskFillTheBlankCard.vue?vue&type=script&lang=ts&"
export * from "./TaskFillTheBlankCard.vue?vue&type=script&lang=ts&"
import style0 from "./TaskFillTheBlankCard.vue?vue&type=style&index=0&id=3d835984&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d835984",
  null
  
)

export default component.exports